import Home from '@/app/views/home.vue'
import Evaluations from '@/app/views/evaluations.vue'
import Terms from '@/app/views/terms.vue'
import GDPR from '@/app/views/gdpr.vue'
import FAQ from '@/app/views/faq.vue'
import About from '@/app/views/about.vue'
import Imprint from '@/app/views/imprint.vue'
import Tenants from '@/tenants/views/tenants.vue'
import EmailConfirm from '@/users/views/email-confirm.vue'
import Login from '@/users/views/login.vue'
import Permissions from '@/users/views/permissions.vue'
import Register from '@/users/views/register.vue'
import SetPassword from '@/users/views/set-password.vue'
import ResetPassword from '@/users/views/reset-password.vue'
import Settings from '@/users/views/settings.vue'
import Users from '@/users/views/users.vue'
import Error from '@/app/views/error.vue'
import InitSort from '@/app/views/initsort.vue'
import Templates from '@/templates/views/templates.vue'

import Competences from '@/competences/views/competences.vue'

import EvaluationSettings from '@/evaluations/views/evaluation-settings.vue'
import EvaluationDetails from '@/evaluations/views/evaluation-details.vue'
import EvaluationCandidate from '@/evaluations/views/evaluation-candidate.vue'

import RatingList from '@/evaluations/views/rating-list.vue'
import RatingCandidate from '@/evaluations/views/rating-candidate.vue'

export default {
  // Default route the user will be redirected to if none is specified in the
  // request params.
  loginDefaultRedirect: {
    ADMIN: 'home',
    TENANT: 'home',
    USER: 'home',
    DEFAULT: 'home',
  },

  // Route to redirect to after a successful logout.
  logoutRedirect: 'login',

  routes: [
    //-------------------------------------------------------------------------
    // Project-independent routes.
    //-------------------------------------------------------------------------
    {
      path: '/:lang?',
      name: 'default',
      component: Home,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.home.title',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/home',
      name: 'home',
      component: Home,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.home.title',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/evaluations',
      name: 'evaluations',
      component: Evaluations,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.evaluations.title',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/terms',
      name: 'terms',
      component: Terms,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.terms.title',
      },
    },
    {
      path: '/:lang?/gdpr',
      name: 'gdpr',
      component: GDPR,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.gdpr.title',
      },
    },
    {
      path: '/:lang?/imprint',
      name: 'imprint',
      component: Imprint,
      meta: {
        layout: 'sidebar-layout',
        title: 'app.pages.imprint.title',
      },
    },
    {
      path: '/:lang?/initsort',
      name: 'initsort',
      component: InitSort,
      meta: {
        layout: 'sidebar-layout',
        title: 'Sortierung initialisieren',
      },
    },
    {
      path: '/:lang?/faq',
      name: 'faq',
      component: FAQ,
      meta: {
        layout: 'sidebar-layout',
        title: 'FAQ',
      },
    },
    {
      path: '/:lang?/about',
      name: 'about',
      component: About,
      meta: {
        layout: 'sidebar-layout',
        title: 'Über uns',
      },
    },
    {
      path: '/:lang?/:user/email-confirm/:token',
      name: 'email-confirm',
      component: EmailConfirm,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/login/:redirectUrl?',
      name: 'login',
      component: Login,
      meta: {
        layout: 'header-layout',
      },
    },
    {
      path: '/:lang?/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'header-layout',
      },
    },
    {
      path: '/:lang?/:email/set-password/:token',
      name: 'set-password',
      component: SetPassword,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/:email/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/settings',
      name: 'settings',
      component: Settings,
      meta: {
        layout: 'sidebar-layout',
        title: 'users.pages.settings.title',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/users',
      name: 'users',
      component: Users,
      meta: {
        layout: 'sidebar-layout',
        title: 'users.pages.users.title.plural',
        requiresAuth: true,
        roles: ['ADMIN', 'TENANT'],
      },
    },
    {
      path: '/:lang?/tenants',
      name: 'tenants',
      component: Tenants,
      meta: {
        layout: 'sidebar-layout',
        title: 'tenants.pages.tenants.title.plural',
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },
    {
      path: '/:lang?/templates',
      name: 'templates',
      component: Templates,
      meta: {
        layout: 'sidebar-layout',
        title: 'common.components.templates.title',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/permissions',
      name: 'permissions',
      component: Permissions,
      meta: {
        layout: 'sidebar-layout',
        title: 'users.pages.permissions.title',
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },

    {
      path: '/:lang?/competences',
      name: 'competences',
      component: Competences,
      meta: {
        layout: 'sidebar-layout',
        title: 'competences.pages.competences.title',
        requiresAuth: true,
      },
    },

    {
      path: '/:lang?/evaluations/:id/details',
      name: 'evaluationdetails',
      component: EvaluationDetails,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'evaluations.pages.evaluation-details.title',
        requiresAuth: true,
      },
    },

    {
      path: '/:lang?/evaluations/:evaluationId/details/:candidateId',
      name: 'evaluationCandidate',
      component: EvaluationCandidate,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'evaluations.pages.evaluation-candidate.title',
        requiresAuth: true,
      },
    },

    {
      path: '/:lang?/evaluations/create',
      name: 'evaluationcreate',
      component: EvaluationSettings,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'evaluations.pages.evaluation-settings.title',
        requiresAuth: true,
      },
    },

    {
      path: '/:lang?/evaluations/:id/edit',
      name: 'evaluationedit',
      component: EvaluationSettings,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'evaluations.pages.evaluation-settings.title',
        requiresAuth: true,
      },
    },

    {
      path: '/:lang?/ratings/:eId/judge/:jId',
      name: 'ratinglist',
      component: RatingList,
      props: true,
      meta: {
        layout: 'empty-layout',
        title: 'evaluations.pages.evaluation-settings.title',
        requiresAuth: false,
      },
    },

    {
      path: '/:lang?/ratings/:eId/judge/:jId/candidate/:cId',
      name: 'ratingcandidate',
      component: RatingCandidate,
      props: true,
      meta: {
        layout: 'empty-layout',
        title: 'evaluations.pages.evaluation-sheet.title',
        requiresAuth: false,
      },
    },

    {
      path: '/:lang?/evaluationsettings',
      name: 'evaluationsettings',
      component: EvaluationSettings,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'evaluations.pages.evaluation-settings.title',
        requiresAuth: true,
      },
    },

    //-------------------------------------------------------------------------
    // Error page.
    //-------------------------------------------------------------------------
    {
      path: '/error/:status',
      name: 'error',
      component: Error,
      meta: {
        layout: 'empty-layout',
      },
    },

    // Fallback redirect.
    { path: '*', redirect: '/error/404' },
  ],
}
